<div class="modal-header">
    <h2 class="modal-title">Fee Type</h2>
</div>
<div class="flex-fill d-flex flex-column">
    <div class="card">
        <div class="card-body">
            <dx-form *ngIf="feeType" [formData]="feeType" validationGroup="feeTypeValidationGroup">
                <dxi-item itemType="group">
                    <dxi-item dataField="name">
                        <dxi-validation-rule type="required"> </dxi-validation-rule>
                    </dxi-item>
                    <dxi-item dataField="quickBooksInvoiceAccount"></dxi-item>
                    <dxi-item dataField="quickBooksPaymentAccount"> </dxi-item>
                    <dxi-item
                        [label]="{ text: 'Type' }"
                        editorType="dxRadioGroup"
                        [editorOptions]="{
                            items: baseTypes,
                            value: this.feeType.amountBased ? baseTypes[1] : this.feeType.percentageBased ? baseTypes[0] : null,
                            onValueChanged: typeChanged
                        }"
                    >
                        <dxi-validation-rule type="required"> </dxi-validation-rule>
                    </dxi-item>
                    <dxi-item dataField="defaultAmount" editorType="dxNumberBox" [editorOptions]="{ step: 0 }">
                        <dxi-validation-rule type="required"> </dxi-validation-rule>
                    </dxi-item>
                </dxi-item>
            </dx-form>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button class="btn btn-danger" (click)="save()">Save</button>
    <button class="btn btn-success" (click)="close()">Close</button>
</div>
